import { 
    GET_SERVER,
    GET_VERSION,
    GET_IP
  } from './types';
  
import axios from 'axios';

export const getServer = ( sServer ) => {

    return async(dispatch) => {
        const reqBody = {   
            "jsonrpc": 2.0,
            "method": "config.meta.getStartup",
            "id": 200
        };

        await axios({
            method: 'post',
            url: sServer,
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: reqBody,
            timeout: 6000
        })
        .then( response => {
            const data = response.data.result[1];
            let general =  data[Object.keys(data)[0]];
            let eview = general.rgsFeature.includes('eview');
            let authServers = data[Object.keys(data)[1]];
            let usersOnline = data[Object.keys(data)[2]]
            let sApiToken = authServers && authServers[0] ? authServers[0].sApiToken : '' ;

            dispatch({
                type: GET_SERVER,
                bSerial: general.bSerial,
                sName: general.sName,
                sVersion: general.sVersion,
                sApiToken: sApiToken,
                bNumcams: general.bNumcams,
                fEview: eview,
                authServers, // an array of objects with properties: { bPort, bRtspPort, bSerial, bTimestamp, fLocal, sIP, sLocalIP, sName, sVersion }
                usersOnline // an array of users online [ 'username', 'username' ]
            })
        })
        .catch(error => {
            console.error('Error:', error);
        }); 
    };
}; 

export const getVersion = ( session, server ) => {
    return (dispatch) => {
        // make an axios request to json-rpc
        dispatch({ type: GET_VERSION })
    };
};
    
export const getIp = ( session, server ) => {
    return (dispatch) => {
        // make an axios request to json-rpc
        dispatch({ type: GET_IP })
    };
};
  
export const isAlive = (serverUrl) => {
    return async( dispatch ) => {
        const reqBody = {   "jsonrpc": 2.0,
                            "method": "info.isAlive",
                            "id": 200
                        };
        await axios({
            method: 'post',
            url: serverUrl,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            data: reqBody,
            timeout: 2000
        })
        .then( response => {
   
            const data = response.data.result[1]
        
            if(!data) {
                return false;
            }
            return true;
        })
        .catch(error => {
            console.error('Error:', error);
            return false;
        }); 
    };
};
